import classNames from 'classnames';
import React, { useState } from 'react';
import Button from '../../components/Button';
import PopOver from '../../components/deprecated/PopOver';
import PopOverContainer from '../../components/deprecated/PopOverContainer';
import OverflowMenu from '../../components/OverflowMenu';
import SVGIcon from '../../components/SVGIcon';
import overflowMenuIcon from '../../icons/overflowMenu.svg';
import reactionIcon from '../../icons/reaction.svg';
import styles from './CommentButtons.module.scss';
import EmojiPicker from './EmojiPicker';

interface CommentButtonsProps {
  showing: boolean;
  emojiPickerOpen: boolean;
  onEmojiPickerOpenChange: (open: boolean) => void;
  toggleCommentReaction: (emoji: string) => void;
  menuItems: React.ReactNode[];
}

const CommentButtons = ({
  showing,
  emojiPickerOpen,
  onEmojiPickerOpenChange,
  toggleCommentReaction,
  menuItems,
}: CommentButtonsProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  if (!showing && !emojiPickerOpen && !isMenuOpen) return null;

  return (
    <div className={classNames(styles.container)}>
      {/* @ts-expect-error */}
      <PopOver
        placement="bottom-end"
        open={emojiPickerOpen}
        onOpenChange={onEmojiPickerOpenChange}
        disablePersist
        preventCloseOnContentClick
        trigger="click"
        popOver={
          <PopOverContainer noPadding>
            <EmojiPicker
              onPick={(emoji) => {
                onEmojiPickerOpenChange(false);
                toggleCommentReaction(emoji);
              }}
            />
          </PopOverContainer>
        }
        popOverPortal={document.body}
      >
        <Button
          icon={reactionIcon}
          className={classNames({ [styles.active]: emojiPickerOpen })}
        />
      </PopOver>
      {menuItems.length > 0 && (
        <>
          <div className={styles.separator} />
          <OverflowMenu
            inline={false}
            open={isMenuOpen}
            onOpenChange={setIsMenuOpen}
            button={
              <Button className={classNames({ [styles.active]: isMenuOpen })}>
                <SVGIcon coloringWith="fill">{overflowMenuIcon}</SVGIcon>
              </Button>
            }
          >
            {menuItems}
          </OverflowMenu>
        </>
      )}
    </div>
  );
};

export default CommentButtons;
